<template>
    <div>
        <div class="cancel-pay-modal modal fade" tabindex="-1" role="dialog" aria-labelledby="cancelPayModal" aria-hidden="true">
            <div class="modal-pdv">
                <div class="modal-content">
                    <div class="modal-title">
                        <!--button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button-->
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <img src="/images/featured/close-circle-menu.svg" alt="close-circle-menu" /> 
                        </button>
                    </div>
                    <div class="main-content">
                        <div class="row">
                            <div class="col text-content">
                                <img src="/images/iconos/error-pago.png" alt="">
                                <div class="flex flex-col justify-content-center">
                                    <h5>LO SENTIMOS! <br>NO SE PUDO EJECUTAR EL PAGO</h5>
                                    <h6>Ningún cargo fue realizado en tu tarjeta. Vuelve a intentarlo para no perder los horarios que seleccionaste.</h6>
                                    <!--button @click="onPay" type="button" class="btn-pdv-primary pay-button"><vue-progress-bar></vue-progress-bar>PAGAR</button-->
                                    <Button 
                                      title="PAGAR"
                                      type="primario"
                                      size="medium"
                                      @onClick="onPay"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                   
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import Button from "@/components/featured/Button";
    export default {
        data(){
          return {

          }
        },

        computed:{
        },

        components: {
            Button
        },

        methods:{
            onPay(){
                 this.$emit('onPay')
            }
        },

        mounted() {
        }

    }
</script>

<style scoped lang="scss">
    .cancel-pay-modal{
        @include media-breakpoint-down(sm){
            padding-right: 0 !important;
        }
        .modal-pdv{
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            display: -webkit-box;
            display: -ms-flexbox;
            -webkit-box-pack: center;
            -ms-flex-pack: center;
            justify-content: center;
            z-index: 1000;
            overflow: hidden;
            display: flex;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            height: 100vh;
            background: rgba(134,133,133,.1);
            .modal-content{
                position: relative;
                width: 45%;
                border-radius: 24px;
                border: 2px solid #1b1b1d;
                background: #fff;
                padding: 24px;
                -webkit-box-shadow: 0 0 12px 3px rgba(0,0,0,.2196078431372549);
                box-shadow: 0 0 12px 3px rgba(0,0,0,.2196078431372549);
                min-height: 330px;

                @include media-breakpoint-down(sm){
                    width: 90%;
                }
                h5 {
                    margin-bottom: 0;
                    color: #592466;
                    text-align: center;
                    font-family: Poppins-Bold,sans-serif;
                    font-size: 32px;
                    font-style: normal;
                    font-weight: 700;
                    line-height: 42px;
                    margin-bottom: 10px;
                }
                h6 {
                    color: #1b1b1d;
                    text-align: center;
                    font-family: Poppins-Regular,sans-serif;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 24px;
                    margin-bottom: 0;
                    text-align: center;
                    margin-bottom: 20px;
                }

                button{
                    text-align: center;
                }
                .modal-title{
                    button.close{
                        position: absolute;
                        right: 15px;
                        top: 15px;
                        opacity: 1;
                        span{
                            font-size: 30px;
                            color: $brown-light;
                        }
                    }
                }
                .main-content{
                    min-height: 350px;
                    display: flex;
                    align-items: center;
                    h3{
                        font-size: 20px;
                        line-height: 23px;
                        @include alternative-bold;
                    }
                    p {
                        font-size: 18px;
                        line-height: 26px;
                        @include alternative-regular;
                        margin-bottom: 19px;
                    }
                    .text-content {
                        display: flex;
                        align-items: center;
                        img{
                            margin-right: 30px;
                            width: 203px;
                        }
                        @include media-breakpoint-down(sm){
                            display: block;
                            text-align: center;
                            img{
                                margin-right: 0;
                                margin-bottom: 18px;
                                width: 146px;
                            }
                        }
                    }
                    .pay-button {
                         @include media-breakpoint-up(sm){
                             width:160px;
                        }
                    }
                }

            }

        }
    }

</style>